<template>
    <div>
        <div class="input-group ">
            <template v-if="label">
                <div class="input-group-prepend w-35 mw-auto">
                    <span class="input-group-text w-100">
                        {{label}}
                        <small class="red--text" v-if="this.require">【必須】</small>
                    </span>
                </div>
            </template>
            <label class="h-100 my-auto px-2">
                <input type="hidden" v-bind:name="name" value="0"/>
                <input false-value="false" true-value="true" type="checkbox" v-bind:class="classes"
                       v-bind:id="id" v-bind:name="name" v-bind:readonly="readonly" v-model="input"
                       value="1">
            </label>
            <div class="invalid-feedback d-block">{{ error }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "inputCheckComponent",
        props: {
            label: String,
            name: String,
            id: String,
            classes: String,
            value: [Boolean, Number, String],
            require: {
                type: Boolean,
                default: false
            },
            default_error: String,
        },
        data() {
            return {
                innerValue: null,
                error: null,
                readonly: false,
            }
        },
        mounted() {
            if (this.isVertical === undefined) {
                this.isVertical = false;
            }
            this.setChangeTrigger();
            if (this.value === 0 || this.value === "0") {
                this.input = "false";
            } else if (this.value === 1 || this.value === "1") {
                this.input = "true";
            } else {
                this.input = this.value;
            }
            this.error = this.default_error;
        },
        watch: {
            '$attrs.input': function () {
                this.input = this.$attrs['input'];
            }
        },
        methods: {
            setChangeTrigger() {
                const self = this;
                $(this.$el).find('input').on('change', function () {
                    self.input = $(this).val();
                });
            }
        },
        computed: {
            input: {
                get() {
                    return this.innerValue;
                },
                set(newValue) {
                    if (newValue === "true" || newValue === true) {
                        this.innerValue = true;
                        return this.$emit('update:input', true);
                    } else if (newValue === "false" || newValue === false) {
                        this.innerValue = false;
                        return this.$emit('update:input', false);
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>